import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Box } from '@mui/material';
import AlertMessageStyles from './AlertMessage.styles';
import { AlertIconProps } from './types';

const AlertIcon = ({ action, config }: AlertIconProps) => {
  const IconComponent = config.icon;

  return (
    <Box
      role="img"
      aria-label={`Alert icon for ${action} action`}
      className={AlertMessageStyles.iconContainer}
      sx={{
        backgroundColor: config.backgroundColor,
        color: config.iconColor,
      }}
    >
      <AutoAwesomeIcon
        className={AlertMessageStyles.awesomeIcon}
        aria-hidden="true"
      />
      <IconComponent aria-hidden="true" />
    </Box>
  );
};

export default AlertIcon;
